export default "__VITE_ASSET__DUAgZXe0__"